import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import SiteSidebar from '#modules/sites/components/SiteSidebar.vue';

export default defineModule({
    name: 'sites',
    routes: [
        {
            path: '/sites',
            meta: {
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                {
                    path: '',
                    name: 'sites.index',
                    component: () => import('#modules/sites/pages/index.vue'),
                    meta: {
                        layout: 'app',
                    },
                },
                {
                    path: ':site',
                    meta: {
                        layout: 'app-sidebar',
                        sidebar: SiteSidebar,
                    },
                    children: [
                        {
                            path: '',
                            name: 'sites.show',
                            component: () => import('#modules/sites/pages/show.vue'),
                        },
                        {
                            path: 'databases',
                            children: [
                                {
                                    path: '',
                                    name: 'sites.databases.index',
                                    component: () => import('#modules/sites/pages/databases/index.vue'),
                                },
                                {
                                    path: 'users',
                                    name: 'sites.databases.users.index',
                                    component: () => import('#modules/sites/pages/databases/users/index.vue'),
                                },
                                {
                                    path: 'users/:user',
                                    name: 'sites.databases.users.show',
                                    component: () => import('#modules/sites/pages/databases/users/show.vue'),
                                },
                                {
                                    path: ':database',
                                    name: 'sites.databases.show',
                                    component: () => import('#modules/sites/pages/databases/show.vue'),
                                },
                            ],
                        },
                        {
                            path: 'sftp',
                            name: 'sites.sftp',
                            component: () => import('#modules/sites/pages/sftp.vue'),
                        },
                        {
                            path: 'ssh-keys',
                            name: 'sites.ssh-keys',
                            component: () => import('#modules/sites/pages/ssh-keys.vue'),
                        },
                        {
                            path: 'redis',
                            name: 'sites.redis',
                            component: () => import('#modules/sites/pages/redis.vue'),
                        },
                        {
                            path: 'password-protection',
                            name: 'sites.basic-authentication',
                            component: () => import('#modules/sites/pages/password-protections.vue'),
                        },
                        {
                            path: 'malware',
                            name: 'sites.malware',
                            component: () => import('#modules/sites/pages/malware.vue'),
                        },
                        {
                            path: 'access-logs',
                            name: 'sites.access-logs',
                            component: () => import('#modules/sites/pages/access-logs.vue'),
                        },
                        {
                            path: 'error-logs',
                            name: 'sites.error-logs',
                            component: () => import('#modules/sites/pages/error-logs.vue'),
                        },
                        {
                            path: 'backups',
                            name: 'sites.backups',
                            component: () => import('#modules/sites/pages/backups.vue'),
                        },
                        {
                            path: 'cron-jobs',
                            name: 'sites.cron-jobs',
                            component: () => import('#modules/sites/pages/cron-jobs.vue'),
                        },
                        {
                            path: 'ssl-certificates',
                            name: 'sites.ssl',
                            component: () => import('#modules/sites/pages/ssl.vue'),
                        },
                        {
                            path: 'file-manager',
                            name: 'sites.file-manager',
                            component: () => import('#modules/sites/pages/file-manager.vue'),
                        },
                        {
                            path: 'monitoring',
                            name: 'sites.monitoring',
                            component: () => import('#modules/sites/pages/monitoring.vue'),
                        },
                    ],
                },
            ],
        },
    ],
});
